import { useEffect } from "react";

import { ClientEditForm } from "../../clientEdit";

// ClientEditModal — feature-local T-1 parent-owned modal.
//
// Closed-class reference: architecture-freeze-r8.md §4 T-1
// ("modal triggered from parent header; mutation owns client core
// slice; success refetches parent on close").
//
// Ownership:
//   * open/close state — owned by the parent (ClientDetailScreenContent)
//     via plain useState; this component is fully controlled.
//   * mutation — owned by ClientEditForm (unchanged); this widget
//     only relays its onSuccess hand-off into onSaved.
//   * post-save freshness — owned by the parent (calls its existing
//     handleReload). No cross-section refresh; no orchestration.
//
// Effects in this primitive are limited to the allowed UI-local
// effects per CLAUDE.md "Presentation Primitive Rules": ESC-key
// handler and body scroll lock. No selectors, no dispatch, no
// imperative handle, no registry, no portal, no shared modal host.

function ClientEditModal({ open, onClose, clientId, onSaved }) {
  useEffect(() => {
    if (!open) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="feature-client-detail__modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="client-edit-modal-title"
    >
      <div
        className="feature-client-detail__modal-backdrop"
        aria-hidden="true"
        onClick={onClose}
      />
      <div className="feature-client-detail__modal-dialog">
        <header className="feature-client-detail__modal-head">
          <h2
            id="client-edit-modal-title"
            className="feature-client-detail__modal-title"
          >
            <i className="fa-solid fa-pen-to-square" aria-hidden="true" />
            <span>Редагування клієнта</span>
          </h2>
          <button
            type="button"
            className="feature-client-detail__modal-close"
            onClick={onClose}
            aria-label="Закрити вікно редагування"
            title="Закрити"
          >
            <i className="fa-solid fa-xmark" aria-hidden="true" />
          </button>
        </header>
        <div className="feature-client-detail__modal-body">
          <ClientEditForm clientId={clientId} onSuccess={onSaved} />
        </div>
      </div>
    </div>
  );
}

export default ClientEditModal;
